"use client";

import { c as _c } from "react/compiler-runtime";
import { ComingSoonPage } from "@/components/coming-soon-page";
export default function PickleballPage() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ComingSoonPage sportName="Pickleball" waitlistType="pickleball_waitlist" iconSrc="/drawables/icon_pickleball.png" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}